// Largo de una contraseña nueva (crear la cuenta, cambiarla o recuperarla). Lo mismo revisan el servidor (utils/contrasenas.js) y la app:
// si aquí pasa, allá también y nunca falla hasta el final. El máximo es por bcrypt, que solo usa los primeros 72 bytes.
export const CONTRASENA_MIN = 8;
export const CONTRASENA_MAX = 64;
export const REGLA_CONTRASENA = `Tu contraseña debe tener entre ${CONTRASENA_MIN} y ${CONTRASENA_MAX} caracteres.`;

// Por qué no sirve, o '' si sirve. Se cuentan caracteres (un emoji vale 1, no 2 como en .length), igual que el servidor.
export const errorDeContrasena = (password = '') => {
  const largo = Array.from(password).length;
  if (largo < CONTRASENA_MIN) return `La contraseña debe tener al menos ${CONTRASENA_MIN} caracteres`;
  if (largo > CONTRASENA_MAX) return `La contraseña puede tener máximo ${CONTRASENA_MAX} caracteres`;
  return '';
};
